import { authenticatedFetch } from '../../api/request';

export default async function cancelLicense(licenseId: number) {
    return await authenticatedFetch(`/v5/userLicenses/${licenseId}/cancelLicense`, {
        method: 'POST'
    });
}
